// 展示店舗一覧モーダル
document.addEventListener('DOMContentLoaded', function () {
  const openButton = document.querySelector('[data-modal-open]');
  if (!openButton) return;

  const modal = document.querySelector(openButton.dataset.modalOpen);
  if (!modal) return;

  const closeButton = modal.querySelector('.exhibition_store__modal_close');
  if (!closeButton) return;

  // モーダルを開く
  openButton.addEventListener('click', () => {
    if (typeof modal.showModal === "function") {
      modal.showModal();
    }
  });

  // モーダルを閉じる
  closeButton.addEventListener('click', () => {
    modal.close();
  });

  // 背景クリックで閉じる
  modal.addEventListener('click', (event) => {
    const rect = modal.getBoundingClientRect();
    const isInDialog =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;

    if (!isInDialog) {
      modal.close();
    }
  });
});

// 商品購入規約チェックボックス
document.addEventListener('DOMContentLoaded', function(event) {
  const targetButton = document.querySelector('.product-form__submit');
  const triggerCheckbox = document.querySelector('input[name="agree"]');
  if (!triggerCheckbox) return;

  targetButton.addEventListener('click', function(event) {
    if (!triggerCheckbox.checked) {
      alert("商品購入規約に同意する必要があります");
      event.preventDefault();
    }
  });
}, false);

// recently viewed
(function() {
  if (window.location.pathname.includes('/products/')) {
    const handle = window.location.pathname.split('/products/')[1].split('/')[0];
    let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

    // Remove duplicates
    recentlyViewed = recentlyViewed.filter(item => item !== handle);

    recentlyViewed.unshift(handle); // Add current product to the beginning
    recentlyViewed = recentlyViewed.slice(0, 8); // Limit to 8 recent items

    localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
  }
})();

// 再入荷ボタンの非表示
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    const addButton = document.querySelector('[name="add"]');
    const stockButton = document.querySelector('.gw-button-widget');
    if (addButton && stockButton && addButton.dataset.backInStock === "true") {
      stockButton.style.display = "none";
    }
  }, 1300);
});

// Judge.me 返信を2行に省略して「開く」ボタンを付ける
(() => {
  function clampReply(reply) {
    if (reply.dataset.clamped) return;

    const content = reply.querySelector('.jdgm-rev__reply-content');
    if (!content) return;

    // ponytail: ウィジェットが非表示のまま挿入される場合があるので、測れるまでフラグを立てず次回に回す
    const natural = content.getBoundingClientRect().height;
    if (!natural) return;

    reply.dataset.clamped = 'true';
    content.classList.add('jdgm-reply-clamp');
    if (content.getBoundingClientRect().height >= natural - 1) return; // 2行以内なら不要

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'jdgm-reply-toggle';
    button.textContent = '＋開く';
    button.addEventListener('click', () => {
      const opened = content.classList.toggle('is-open');
      button.textContent = opened ? '−閉じる' : '＋開く';
    });
    reply.appendChild(button);
  }

  const scan = () => document.querySelectorAll('.jdgm-rev__reply').forEach(clampReply);

  // ウィジェットは非同期描画なので初回 + DOM 変化を監視（rAF で1フレームにまとめる）
  scan();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/**
 * Drag with the mouse to scroll any horizontally overflowing container.
 * Adds `is-dragging` to the container while dragging (style the cursor there).
 * ponytail: delegated on document, so it also covers containers rendered later
 * (the filter chips are re-rendered on every filter change).
 *
 * @param {string} selector CSS selector of the scrollable container(s)
 * @param {number} [threshold=5] px of movement before it counts as a drag, not a click
 */
function enableDragScroll(selector, threshold = 5) {
  document.addEventListener('pointerdown', (event) => {
    if (event.button !== 0 || event.pointerType === 'touch') return; // touch already scrolls natively

    const container = event.target.closest(selector);
    if (!container || container.scrollWidth <= container.clientWidth) return;

    const startX = event.clientX;
    const startScroll = container.scrollLeft;
    let dragged = false;

    const onMove = (e) => {
      const dx = e.clientX - startX;
      if (!dragged) {
        if (Math.abs(dx) < threshold) return;
        dragged = true;
        container.classList.add('is-dragging');
      }
      container.scrollLeft = startScroll - dx;
    };

    const onUp = () => {
      document.removeEventListener('pointermove', onMove);
      container.classList.remove('is-dragging');
      if (!dragged) return;

      // Swallow the click that ends a drag so it doesn't activate a link inside
      const swallow = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      document.addEventListener('click', swallow, { capture: true, once: true });
      // Clean up in case no click ever fires
      setTimeout(() => document.removeEventListener('click', swallow, true), 0);
    };

    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp, { once: true });
    document.addEventListener('pointercancel', onUp, { once: true });
  });
}

enableDragScroll('.f-current__list');

//外部サイトリンクの開き方
var links = document.links;
 for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
   links[i].target = '_blank';
   links[i].rel = 'noreferrer noopener';
  }
 }